const musicGenreEmojis = new Map([  
  ['Rock', '🎸🤘🎵'],
  ['Pop', '🎤🎶🕺'],
  ['Classical', '🎻🎼🎩'],
  ['Hip Hop', '🎧🔥🎤'],
  ['Country', '🤠🎵🎸'],
  ['Jazz', '🎷🎶🎹'],
  ['Reggae', '🎵🌴🎤'],
  ['Electronic', '🎧🎹💥'],
  ['R&B', '🎤🎶💃'],
]);

export default musicGenreEmojis;
